import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Sparkles, ArrowRight, Check } from "lucide-react";
import { useAuth, login } from "@/context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Left: form */}
      <div className="flex flex-col justify-center px-6 py-12 sm:px-16">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary">
            <Sparkles className="h-4 w-4 text-gold" />
          </span>
          <span className="font-serif text-xl font-semibold">God<span className="text-gold">inga</span></span>
        </Link>

        <div className="mt-16 max-w-sm">
          <p className="eyebrow text-gold">Godinga team sign in</p>
          <h1 className="mt-3 font-serif text-4xl font-semibold tracking-tight">Welcome back</h1>
          <p className="mt-3 text-muted-foreground">
            Access is limited to approved Godinga team members. Sign in with your Google account —
            new members are activated once an administrator approves your request.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={login}
            className="mt-8 flex w-full items-center justify-center gap-3 rounded-full border border-border bg-card px-6 py-3.5 text-sm font-semibold transition-all hover:shadow-lg"
          >
            <img src="https://www.google.com/favicon.ico" alt="" className="h-5 w-5" />
            Continue with Google
            <ArrowRight className="h-4 w-4" />
          </button>

          <div className="mt-8 space-y-2.5 text-sm text-muted-foreground">
            {["Approved team members only", "Admin-controlled access", "Guests still RSVP without an account"].map((t) => (
              <p key={t} className="flex items-center gap-2"><Check className="h-4 w-4 text-gold" /> {t}</p>
            ))}
          </div>
          <Link to="/" className="mt-10 inline-block text-sm text-muted-foreground hover:text-foreground">← Back to home</Link>
        </div>
      </div>

      {/* Right: visual */}
      <div className="relative hidden bg-cover bg-center lg:block" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80)" }}>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/40" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="font-serif text-3xl font-medium leading-tight">"The elegant way to gather."</p>
          <p className="mt-3 text-white/70">Beautiful event pages and effortless RSVPs for weddings, galas and celebrations.</p>
        </div>
      </div>
    </div>
  );
}
